import { Suspense } from "react";
import { useParams, Outlet } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { getProductLibProduct } from "../../graphql/queries";
import wrapPromise from "../../helpers/wrapPromise";
import ProductContext from "../../contexts/ProductContext";
import Waiting from "../../components/Waiting";
import { extractProduct } from "../../helpers/extract";

function Product() {
  const params = useParams();
  const productId = params.productId ? params.productId : "";

  const fetchProductData = () => {
    const product: any = API.graphql(
      graphqlOperation(getProductLibProduct, { id: productId })
    );

    return {
      product: wrapPromise(product),
    };
  };

  const pd = fetchProductData();

  const ShowProduct = ({ pd }: any) => {
    const product = pd.product.read();
    const productInfo = extractProduct(product);
    if (!productInfo) {
      return <></>; //go to un auth page.
    }

    const productMainImages = productInfo.images
      ? JSON.parse(productInfo.images)
      : [];
    const productTags = productInfo.tags ? JSON.parse(productInfo.tags) : [];
    const productFiles = productInfo.files ? productInfo.files.items : [];
    const productFunctions = productInfo.functions
      ? JSON.parse(productInfo.functions)
      : [];

    return (
      <>
        <ProductContext.Provider
          value={{
            product: {
              ...productInfo,
              images: productMainImages,
              tags: productTags,
              files: productFiles,
              functions: productFunctions,
            },
          }}
        >
          <Outlet />
        </ProductContext.Provider>
      </>
    );
  };

  return (
    <Suspense fallback={<Waiting />}>
      <ShowProduct pd={pd} />
    </Suspense>
  );
}
export default Product;
